// Importación inicial
import React, { useEffect, useState } from 'react';
import { alpha } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Stack from "@mui/material/Stack";

import AppTheme from "../../../shared-theme/AppTheme";
import {
  Box,
  Button,
  Checkbox,
  Container,
  FormControl,
  FormControlLabel,
  TextField,
  Typography,
  IconButton,
  Switch,
  Alert
} from '@mui/material';
import { alignItems, Grid } from '@mui/system';
import Selector from '../../../components/Selector';
import SideMenu from '../../../components/SideMenu';
import AppNavbar from '../../../components/AppNavbar';
import Header from '../../../components/Header';
import SelectorChips from '../../../components/SelectorChips';
import { Add, ArrowBack, RemoveCircleOutline } from '@mui/icons-material';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  DndContext,
  closestCenter
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
  useSortable
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { tiposDeProductosFinancieros, camposProductosFinancieros, categoriasCamposProductosFinan, tiposDeMora, tiposDeInteres, tiposCampos } from '../../../utils/staticvariables';
import { useNavigate } from 'react-router-dom';
import { fetchCategorias, fetchSucursales } from '../../../utils/generalsFetch';
import AlertMessageDialog from '../../../components/Dialogs/alertMessageDialog';
import { formatNumber, formatNumberWithCommas } from '../../../utils/generalFunctions';
import { useParams } from 'react-router-dom';


let uniqueId = 1000;


const SortableItem = ({ key,id, getFieldById, handleFieldChange, handleRemoveOption, removeField, categorias, handleKeyDown}) => {
  const field = getFieldById(id);
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable({ id });

  if (!field) return null;

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    alignItems: "left",
    border: '1px solid #e0e0e0',
    borderRadius: 8,
    padding: 16,
    backgroundColor: '#fff',
    marginBottom: 16,
  };

  return (
    <Box ref={setNodeRef} style={style} {...attributes}>
      <Box display="flex" alignItems="center">
        <IconButton {...listeners}>
          <DragIndicatorIcon />
        </IconButton>
        <Box display="flex" gap={2} alignItems="center" flexWrap="wrap">
          <TextField
            disabled={!field.deletelable}
            placeholder="Nombre del campo"
            value={field.name}
            onChange={(e) => handleFieldChange(field.id, 'name', e.target.value)}
            sx={{ flex: 1, minWidth: 180 }}
          />
          <FormControl sx={{ minWidth: 140 }}>
            <Selector
              disabled={!field.deletelable}
              value={field.type}
              onChange={(e) => handleFieldChange(field.id, 'type', e.target.value)}
              options={tiposCampos}
              placeholder="Tipo"
            />
          </FormControl>
          <FormControlLabel
            disabled={!field.deletelable}
            control={
              <Switch
                checked={field.required}
                onChange={(e) => handleFieldChange(field.id, 'required', e.target.checked)}
              />
            }
            label="¿Requerido?"
          />
          {field.deletelable && (
            <IconButton onClick={() => removeField(field.id)}>
              <RemoveCircleOutline sx={{ color: "red" }} />
            </IconButton>
          )}
        </Box>
    
      </Box>
      {field.type === 'select' && (
        <Box py={1}>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1 }}>
            {(Array.isArray(field.options) ? field.options : []).map((opt, idx) => (
              <Box key={idx} sx={{ display: 'flex', alignItems: 'center', backgroundColor: '#e0e7ff', color: '#1e40af', px: 1.5, py: 0.5, borderRadius: 1, fontSize: '0.85rem' }}>
                {opt}
                {field.deletelable && (
                <IconButton onClick={() => handleRemoveOption(field.id, idx)} size="small" sx={{ ml: 0.5 }}>
                  <RemoveCircleOutline sx={{ color: 'red' }} fontSize="small" />
                </IconButton>
                )}
              </Box>
            ))}
          </Box>
          { field.deletelable && (
          <TextField
            disabled={!field.deletelable}
            placeholder="Escribe tus opciones y presiona Enter o coma"
            value={field.inputValue}
            onChange={(e) => handleFieldChange(field.id, 'inputValue', e.target.value)}
            onKeyDown={(e) => handleKeyDown(e, field.id)}
            fullWidth
            size="small"
          />
          )}
        </Box>
      )}
      {field.deletelable && (
      <Box display="flex" alignItems="left">
        <FormControlLabel sx={{ alignItems: "left" }}
            control={<Checkbox checked={field.busqueda} onChange={(e) => handleFieldChange(field.id, 'busqueda', e.target.value)}/>}
            label="Campo de busqueda?"
          />
      </Box>
      )}
    </Box>
  );
};

const ProdFinancieroDetalle = (props) => {

  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState();
  const [autorizado, setAutorizado] = useState(false);
  const [productType, setProductType] = useState('');
  const [opcionesSucursales, setOpcionesSucursales] = useState([]);
  const [opcionesSucursalesSelected, setOpcionesSucursalesSelected] = useState([]);
  const [opcionesFrecuenciaDePago, setOpcionesFrecuenciaDePago] = useState([]);
  const [nombreProducto, setNombreProducto] = useState('');
  const [montoMinimo, setMontoMinimo] = useState('');
  const [montoMaximo, setMontoMaximo] = useState('');
  const [montoMinimoNumber, setMontoMinimoNumber] = useState('');
  const [montoMaximoNumber, setMontoMaximoNumber] = useState('');


  const [errores, setErrores] = useState({});
  const [configMora, setConfigMora] = useState({});
  const [configInteres, setConfigInteres] = useState({});

  const [requiereInventario, setRequiereInventario] = useState(false);
  const [productTypes, setProductTypes] = useState(tiposDeProductosFinancieros)
  const [requiereSolicitud, setRequiereSolicitud] = useState(false);

  const [formFields, setFormFields] = useState([]);

  const [nuevaCategoria, setNuevaCategoria] = useState('');
  const [categorias, setCategorias] = useState([]);

  const [categoriasInventario, setCategoriasInventario] = useState([]);
  const [categoriasInventarioSelected, setCategoriasInventarioSelected] = useState([]);

  const [openAlert, setOpenAlert] = useState(false)
  const [openConfirmation, setOpenConfirmation] = useState(false)


  useEffect(() => {
    fetchSucursales({ idcompany: localStorage.getItem('idcompany'), usuarioId: localStorage.getItem('id') })
    .then((data) => {
      setOpcionesSucursales(data);
    })  

    fetchCategorias({ idcompany: localStorage.getItem('idcompany'), usuarioId: localStorage.getItem('id') })
    .then((data) => {
      setCategoriasInventario(data);
    })  

    fetchProductoFinanciero(id)
    .then((data) => {
    })  

  }, []);


 const fetchProductoFinanciero = async (producto_id) => {
    let url = `${process.env.REACT_APP_SERVER_URL}/api/prodfinancieros/detalle/${producto_id}`;
  
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        }
      });
  
      if (!response.ok) {
        const error = await response.json();
        console.log(error)
        throw new Error(error.error || 'Error al cargar producto financiero');
      }

      const data = await response.json();
      const generales = JSON.parse(data.generales); 
      const mora = JSON.parse(data.mora);
      const interes = JSON.parse(data.interes);
      const formulario = JSON.parse(data.formulario);

      setNombreProducto(generales.nombre);
      setProductType(generales.tipo);
      setRequiereInventario(generales.requiereInventario);
      setOpcionesSucursalesSelected(generales.sucursales);
      setOpcionesFrecuenciaDePago(generales.frecuenciaDePago);
      setMontoMinimoNumber(generales.montoMinimo);
      setMontoMinimo(formatNumberWithCommas(generales.montoMinimo.toString()));
      setMontoMaximoNumber(generales.montoMaximo);
      setMontoMaximo(formatNumberWithCommas(generales.montoMaximo.toString()));
      setAutorizado(generales.autorizado);
      setCategoriasInventarioSelected(generales.categoriasInventario);
      setRequiereSolicitud(generales.requiereSolicitud);
      setConfigMora(mora);
      setConfigInteres(interes);
      setFormFields(formulario.campos.map(field => ({
        ...field,
        options: Array.isArray(field.options) ? field.options : []
      })));
      setCategorias(formulario.categorias);



      
      return data;
    } catch (error) {
      console.log(error)
      throw error;
    }
  }

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    setFormFields(prev => {
      const filtered = prev.filter(f => f.category === prev.find(f => f.id === active.id).category);
      const others = prev.filter(f => f.category !== filtered[0].category);

      const oldIndex = filtered.findIndex(f => f.id === active.id);
      const newIndex = filtered.findIndex(f => f.id === over.id);
      const reordered = arrayMove(filtered, oldIndex, newIndex);
      return [...others, ...reordered];
    });
  };

  const addField = (category) => {
    uniqueId += 1; // Increment uniqueId for each new field
    setFormFields([
      ...formFields,
      {
        id: uniqueId,
        name: '',
        deletelable: true,
        type: 'texto',
        required: false,
        options: [],
        inputValue: '',
        category: category
      }
    ]);
  };
    
  const removeField = (id) => {
    setFormFields(prev => prev.filter(field => field.id !== id));
  };

  const handleFieldChange = (id, key, value) => {
    setFormFields(prev =>
      prev.map(field => (field.id === id ? { ...field, [key]: value } : field))
    );
  };
  
  const handleAddOption = (id) => {
    setFormFields(prev =>
      prev.map(field => {
        if (field.id !== id) return field;
        const newOption = field.inputValue.trim();
        if (!newOption) return field;
        return {
          ...field,
          options: [...(Array.isArray(field.options) ? field.options : []), newOption],
          inputValue: ''
        };
      })
    );
  };
  
  const handleRemoveOption = (id, index) => {
    setFormFields(prev =>
      prev.map(field => {
        if (field.id !== id) return field;
        const currentOptions = Array.isArray(field.options) ? field.options : [];
        const updatedOptions = [...currentOptions];
        updatedOptions.splice(index, 1);
        return { ...field, options: updatedOptions };
      })
    );
  };
  
  const handleKeyDown = (e, id) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      handleAddOption(id);
    }
  };
  
  const validarFormulario = () => {
    const nuevosErrores = {};
  
    if (!nombreProducto.trim()) nuevosErrores.nombreProducto = 'Requerido';
    if (!productType) nuevosErrores.tipoProducto = 'Requerido';
    if (!montoMinimoNumber || isNaN(montoMinimoNumber)) nuevosErrores.montoMinimo = 'Requerido';
    if (!montoMaximoNumber || isNaN(montoMaximoNumber)) nuevosErrores.montoMaximo = 'Requerido';
    if (parseFloat(montoMinimoNumber) > parseFloat(montoMaximoNumber)) nuevosErrores.montoMaximo = 'El monto máximo debe ser mayor que el mínimo';
    if (parseFloat(montoMinimoNumber) < 0) nuevosErrores.montoMinimo = 'El monto mínimo no puede ser negativo';
    if (parseFloat(montoMaximoNumber) < 0) nuevosErrores.montoMaximo = 'El monto máximo no puede ser negativo';

    if(requiereInventario && categoriasInventarioSelected.length === 0) nuevosErrores.categoriasInventario = 'Seleccione al menos una categoría de inventario';
    
    if (opcionesSucursalesSelected.length === 0) nuevosErrores.sucursales = 'Seleccione al menos una sucursal';
    if (opcionesFrecuenciaDePago.length === 0) nuevosErrores.frecuenciaDePago = 'Seleccione al menos una frecuencia de pago';
  
    if(!configMora.tipoMora || configMora.tipoMora.length === 0) nuevosErrores.tipoMora = 'Requerido';
    if(!configMora.valorMora || configMora.valorMora.length === 0) nuevosErrores.valorMora = 'Requerido';
    if(configMora.tipoMora === 'por_dias' && !configMora.diasGracia) nuevosErrores.diasGracia = 'Requerido';
    if(configMora.tipoMora === 'por_dias' && !configMora.diasMaximosCobro) nuevosErrores.diasMaximosCobro = 'Requerido';
    if(configMora.tipoMora === 'sobre_capital_vencido' && !configMora.frecuenciaCobro) nuevosErrores.frecuenciaCobro = 'Requerido';
    if(configMora.tipoMora === 'sobre_interes_vencido' && !configMora.frecuenciaCobro) nuevosErrores.frecuenciaCobro = 'Requerido';
    if(configMora.tipoMora === 'por_dias' && configMora.aplicaSoloPrimerosDias && !configMora.limiteDiasParaAplicar) nuevosErrores.limiteDiasParaAplicar = 'Requerido';
    


    if(!configInteres.tipoInteres ||configInteres.tipoInteres.length === 0) nuevosErrores.tipoInteres = 'Requerido';
    if(!configInteres.tipoInteres ||configInteres.tipoInteres === 'fija' && !configInteres.tasa) nuevosErrores.tasa = 'Requerido';
    if(!configInteres.tipoInteres ||configInteres.tipoInteres === 'variable' && (!configInteres.tasa_base || !configInteres.margen)) nuevosErrores.tasa = 'Requerido';
    if(!configInteres.tipoInteres ||configInteres.tipoInteres === 'compuesto' && !configInteres.tasa) nuevosErrores.tasa = 'Requerido';
    if(!configInteres.tipoInteres ||configInteres.tipoInteres === 'anticipado' && !configInteres.tasa) nuevosErrores.tasa = 'Requerido';
    if(!configInteres.tipoInteres ||configInteres.tipoInteres === 'a_vencimiento' && !configInteres.tasa) nuevosErrores.tasa = 'Requerido';
    if(!configInteres.tipoInteres ||configInteres.tipoInteres === 'simple' && !configInteres.tasa) nuevosErrores.tasa = 'Requerido';
    
    if(!configInteres.tipoInteres || configInteres.tipoInteres === 'variable' && (!configInteres.tasa_base || !configInteres.margen))  nuevosErrores.tasa_base = 'Requerido';
    if(!configInteres.tipoInteres || configInteres.tipoInteres === 'variable' && (!configInteres.tasa_base || !configInteres.margen))  nuevosErrores.margen = 'Requerido';
    


    setErrores(nuevosErrores);
    return Object.keys(nuevosErrores).length === 0;
  };
  
  const handleOnNext = async () => {
    if (!validarFormulario()) return;

 
    const newForm = {
      productofinanciero: {
        nombre: nombreProducto,
        tipo: productType,
        requiereInventario: requiereInventario,
        categoriasInventario: !requiereInventario ? [] : categoriasInventarioSelected,
        sucursales: opcionesSucursalesSelected,
        frecuenciaDePago: opcionesFrecuenciaDePago,
        montoMinimo: montoMinimoNumber,
        montoMaximo: montoMaximoNumber,
        requiereSolicitud: requiereSolicitud,
        mora:configMora,
        interes: configInteres,
        autorizado: autorizado,
        formulario:{
            categorias: categorias,
            campos: formFields.map(f => ({
              id: f.id,
              name: f.name,
              type: f.type,
              required: f.required,
              options: f.options,
              category: f.category,
              deletelable: f.deletelable,
              busqueda: f.busqueda
            }))
          }
        }
    };


    let url = `${process.env.REACT_APP_SERVER_URL}/api/prodfinancieros/${id}`;
    try {
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
        body: JSON.stringify(newForm)
      });
  
      if (!response.ok) {
        const error = await response.json();
        console.log(error)
        setOpenAlert(true);
        return;
      }
  
      const data = await response.json();
      console.log(data);
    } catch (error) {
      console.log(error)
      setOpenAlert(true);
      return;
    }

    setOpenConfirmation(true);


  }

      
  
  const getFieldById = (id) => formFields.find(f => f.id.toString() === id.toString());

  const deleteCategory = (cat) => {
    setCategorias(categorias.filter(c => c.name !== cat.name));
    setFormFields(formFields.filter(f => f.category !== cat.name));
  }

  return (
    <Box>
    <AlertMessageDialog message={"Tu producto financiero se ha actualizado con exito."} title={''} severity={"success"} color={"success"} open={openConfirmation} handleClose={()=>{setOpenConfirmation(false);navigate(-1)}}/>
    <AlertMessageDialog message={"Tu producto financiero no se ha podido actualizar."} title={''} severity={"error"} color={"error"} open={openAlert} handleClose={()=>{setOpenAlert(false);}}/>

    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: "flex" }}>
        <SideMenu />
        <AppNavbar />
        {/* Main content */}
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: "auto",
          })}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: "center",
              mx: 3,
              pb: 5,
              mt: { xs: 8, md: 0 },
            }}
          >
            <Header parent={"Gestión Comercial"} child={"Detalle Producto Financiero"} />
            {/* Contenido original aquí */}
            <Box sx={{ minHeight: '100vh', bgcolor: 'transparent', width: '100%' }}>
              <Container maxWidth="lg" sx={{ py: 5}}>
                <Box display="flex" flexDirection={"row"}  gap={3}  marginTop={5}>
                    <Button variant="outlined" color="primarybutton" startIcon={<ArrowBack/>} sx={{fontWeight:"bold"}} onClick={() => {navigate(-1)}}>
                        Atras
                    </Button>
                    <Box display="flex" flexDirection={"column"} textAlign={"left"}>
                        <Typography variant="h4" fontWeight="bold" mb={1}>
                           Detalle Producto Financiero
                        </Typography>
                        <Typography variant="body1" mb={4}>
                          Define el producto financiero que ofrecerá la financiera.
                        </Typography>

                    </Box>

                </Box>
                <Grid container spacing={6} mb={4}>
                  <Grid item xs={12} sm={6} lg={4}>
                    <Box display="flex" flexDirection="column" gap={3}  marginTop={5}>
                      <Typography variant="h6" gutterBottom>Datos Generales</Typography>
                      <TextField
                        placeholder="Nombre del producto"
                        fullWidth
                        value={nombreProducto}
                        onChange={(e) => setNombreProducto(e.target.value)}
                        error={!!errores.nombreProducto}
                        helperText={errores.nombreProducto}
                      />

                      <FormControl fullWidth sx={{mt:-2}}>
                        <Selector
                          value={productType}
                          onChange={(e) => setProductType(e.target.value)}
                          options={productTypes}
                          placeholder="Tipo de producto"
                        />
                        {errores.tipoProducto && (
                          <Typography variant="caption" color="error" textAlign={"start"} sx={{ mt: 0.5 , px:2}}>
                            {errores.tipoProducto}
                          </Typography>
                        )}
                      </FormControl>


                      <FormControlLabel
                          sx={{ mt: -2 }}
                          control={
                            <Checkbox
                              checked={requiereInventario}
                              onChange={(e) => setRequiereInventario(e.target.checked )}
                              
                            />
                          }
                          label="¿Requiere inventario?"
                        />


                      {requiereInventario && (

                        <FormControl fullWidth sx={{mt:-2}}>
                          <Selector
                            value={categoriasInventarioSelected}
                            onChange={(e) => {
                                setCategoriasInventarioSelected(e.target.value);
                            }}
                            options={categoriasInventario}
                            placeholder="Enlazar con inventario"
                          />
                          {errores.categoriasInventario && (
                            <Typography variant="caption" color="error" textAlign={"start"} sx={{ mt: 0.5 , px:2}}>
                              {errores.categoriasInventario}
                            </Typography>
                          )}

                        </FormControl>
                      )}


                      <FormControl fullWidth sx={{mt:-2}}>
                      <Selector
                            multiple
                            value={opcionesSucursalesSelected}
                            onChange={(e) => {
                                setOpcionesSucursalesSelected(e.target.value);
                            }}
                            options={opcionesSucursales}
                            placeholder="Seleccione una o varias sucursales"
                        />
                        {errores.sucursales && (
                          <Typography variant="caption" color="error" textAlign={"start"} sx={{ mt: 0.5 , px:2}}>
                            {errores.sucursales}
                          </Typography>
                        )}

                      </FormControl>

                      <FormControl fullWidth sx={{mt:-2}}>
                        <SelectorChips
                          options={['Diario', 'Semanal', 'Mensual', 'Quincenal']}
                          selected={opcionesFrecuenciaDePago}
                          onChange={(e) => {setOpcionesFrecuenciaDePago(e); 
                            setFormFields(formFields.map(f => {
                              if(f.name === "Frecuencia de pago"){
                                f.options = e
                                return f
                              }
                              return f
                            }))
                          }}
                          placeholder="Frecuencia de pago"
                        />
                        {errores.formaDePago && (
                          <Typography variant="caption" color="error" textAlign={"start"} sx={{ mt: 0.5 , px:2}}>
                            {errores.formaDePago}
                          </Typography>
                        )}

                      </FormControl>

                      <Box display="flex" gap={2} sx={{ mt: -2 }}>
                        <TextField
                          placeholder="Monto mínimo"
                          fullWidth
                          value={montoMinimo}
                          onChange={(e) => {setMontoMinimoNumber(parseInt(e.target.value.replace(/,/g, '')));setMontoMinimo(formatNumberWithCommas(e.target.value))}}
                          error={!!errores.montoMinimo}
                          helperText={errores.montoMaximo}
  
                        />
                        <TextField       
                          placeholder="Monto máximo"
                          fullWidth
                          value={montoMaximo}
                          onChange={(e) => {setMontoMaximoNumber(parseInt(e.target.value.replaceAll(/,/g, '')));setMontoMaximo(formatNumberWithCommas(e.target.value))}}
                          error={!!errores.montoMaximo}
                          helperText={errores.montoMaximo}  
                        />
                      </Box>

                      {/* Configuración de mora */}
                      <Typography variant="h6" gutterBottom mt={4}>Configuración de mora</Typography>

                      <FormControl fullWidth sx={{mt:-2}}>
                        <Selector
                          value={configMora.tipoMora || ''}
                          onChange={(e) => setConfigMora({ ...configInteres, tipoMora: e.target.value })}
                          options={tiposDeMora}
                          placeholder="Tipo de mora"
                        />
                        {errores.tipoMora && (
                          <Typography variant="caption" color="error" textAlign={"start"} sx={{ mt: 0.5 , px:2}}>
                            {errores.tipoMora}
                          </Typography>
                        )}
                      </FormControl>

                      <TextField
                          error={!!errores.valorMora}
                          helperText={errores.valorMora}                
                          fullWidth
                          sx={{mt:-2}}
                          placeholder="Valor mora"
                          value={configMora.valorMora || ''}
                          onChange={(e) => setConfigMora({ ...configMora, valorMora: e.target.value })}
                        />

                      <FormControlLabel
                          sx={{ mt: -2 }}
                          control={
                            <Checkbox
                              checked={configMora.esPorcentaje || false}
                              onChange={(e) => setConfigMora({ ...configMora, esPorcentaje: e.target.checked })}
                              
                            />
                          }
                          label="¿Es porcentaje?"
                        />

                      {configMora.tipoMora === 'por_dias' && (
                        <>
                          <Box display="flex" gap={2} mt={-2}>
                            <TextField
                              fullWidth
                              placeholder="Días de gracia"
                              type="number"
                              value={configMora.diasGracia || ''}
                              onChange={(e) => setConfigMora({ ...configMora, diasGracia: e.target.value })}
                              error={!!errores.diasGracia}
                              helperText={errores.diasGracia}
                            />
                            <TextField
                              fullWidth
                              placeholder="Máx. días para cobrar mora"
                              value={configMora.diasMaximosCobro || ''}
                              onChange={(e) => setConfigMora({ ...configMora, diasMaximosCobro: e.target.value })}
                              type="number"
                              error={!!errores.diasMaximosCobro}
                              helperText={errores.diasMaximosCobro}
                            />
                          </Box>
                          <FormControlLabel
                            sx={{mt:-2}}
                            control={
                              <Checkbox
                                checked={configMora.aplicaSoloPrimerosDias || false}
                                onChange={(e) => setConfigMora({ ...configMora, aplicaSoloPrimerosDias: e.target.checked })}
                              />
                            }
                            label="¿Aplica solo en los primeros días del préstamo?"
                          />
                          {configMora.aplicaSoloPrimerosDias && (
                            <TextField
                              fullWidth
                              placeholder="Límite de días desde el inicio"
                              type="number"
                              value={configMora.limiteDiasParaAplicar || ''}
                              onChange={(e) => setConfigMora({ ...configMora, limiteDiasParaAplicar: e.target.value })}
                              sx={{ mt: -2 }}
                              error={!!errores.limiteDiasParaAplicar}
                              helperText={errores.limiteDiasParaAplicar}
                            />
                          )}
                        </>
                      )}

                      {(configMora.tipoMora === 'sobre_capital_vencido' || configMora.tipoMora === 'sobre_interes_vencido') && (
                        <FormControl fullWidth sx={{ mt: -2 }}>
                          <Selector
                            value={configMora.frecuenciaCobro || ''}
                            onChange={(e) => setConfigMora({ ...configMora, frecuenciaCobro: e.target.value })}
                            options={[
                            ]}
                            placeholder="Frecuencia de cobro"
                          />
                          {errores.frecuenciaCobro && (
                            <Typography variant="caption" color="error" textAlign={"start"} sx={{ mt: 0.5 , px:2}}>
                              {errores.frecuenciaCobro}
                            </Typography>
                          )}
                        </FormControl>
                      )}

                      <Typography variant="h6" gutterBottom fullWidth textAlign={"center"} mt={3}>Configuración de interés</Typography>

                      <FormControl fullWidth>
                        <Selector
                          value={configInteres.tipoInteres || ''}
                          onChange={(e) => setConfigInteres({ ...configInteres, tipoInteres: e.target.value })}
                          options={tiposDeInteres}
                          placeholder="Tipo de interés"
                        />
                      </FormControl>

                      {(configInteres.tipoInteres == 'fija' || configInteres.tipoInteres == 'plazo_indefinido' || configInteres.tipoInteres == 'insoluto') && (
                        <TextField
                          sx={{ mt: -2 }}
                          fullWidth
                          placeholder="Tasa fija (%)"
                          type="number"
                          value={configInteres.tasa || ''}
                          onChange={(e) => setConfigInteres({ ...configInteres, tasa: e.target.value })}
                          error={!!errores.tasa}
                          helperText={errores.tasa}  

                        />
                      )}

                      {configInteres.tipoInteres == 'plazo_indefinido' && (
                        <FormControlLabel
                          sx={{mt:-2}}
                          control={
                            <Checkbox
                              checked={configInteres.interesDiario || false}
                              onChange={(e) => setConfigInteres({ ...configInteres, interesDiario: e.target.checked })}
                            />
                          }
                          label="¿Interes diario?"
                        />
                        )}


                      {configInteres.tipoInteres === 'variable' && (
                        <Box display={"flex"} flexDirection={"row"} gap={2}>
                          <TextField
                            sx={{ mt: -2 }}
                            fullWidth
                            placeholder="Tasa base (%)"
                            type="number"
                            value={configInteres.tasa_base || ''}
                            onChange={(e) => setConfigInteres({ ...configInteres, tasa_base: e.target.value })}
                            error={!!errores.tasa_base}
                            helperText={errores.tasa_base}
                          />
                          <TextField
                            sx={{ mt: -2 }}
                            fullWidth
                            placeholder="Margen fijo (%)"
                            type="number"
                            value={configInteres.margen || ''}
                            onChange={(e) => setConfigInteres({ ...configInteres, margen: e.target.value })}
                            error={!!errores.margen}
                            helperText={errores.margen}
                          />
                        </Box>
                      )}

                      {configInteres.tipoInteres === 'compuesto' && (
                        <TextField
                          sx={{ mt: -2 }}
                          fullWidth
                          placeholder="Tasa de interés compuesto (%)"
                          type="number"
                          value={configInteres.tasa || ''}
                          onChange={(e) => setConfigInteres({ ...configInteres, tasa: e.target.value })}
                          error={!!errores.tasa}
                          helperText={errores.tasa}
                        />
                      )}

                      {configInteres.tipoInteres === 'anticipado' && (
                        <TextField
                          sx={{ mt: -2 }}
                          fullWidth
                          placeholder="Tasa anticipada (%)"
                          type="number"
                          value={configInteres.tasa || ''}
                          onChange={(e) => setConfigInteres({ ...configInteres, tasa: e.target.value })}
                          error={!!errores.tasa}
                          helperText={errores.tasa}
                        />
                      )}

                      {configInteres.tipoInteres === 'a_vencimiento' && (
                        <TextField
                          sx={{ mt: -2 }}
                          fullWidth
                          placeholder="Tasa a pagar en la última cuota (%)"
                          type="number"
                          value={configInteres.tasa || ''}
                          onChange={(e) => setConfigInteres({ ...configInteres, tasa: e.target.value })}
                          error={!!errores.tasa}
                          helperText={errores.tasa}
                        />
                      )}

                      {configInteres.tipoInteres === 'simple' && (
                        <TextField
                          sx={{ mt: -2 }}
                          fullWidth
                          placeholder="Tasa de interés simple (%)"
                          type="number"
                          value={configInteres.tasa || ''}
                          onChange={(e) => setConfigInteres({ ...configInteres, tasa: e.target.value })}
                          error={!!errores.tasa}
                          helperText={errores.tasa}
                        />
                      )}


                      <FormControlLabel
                        control={<Checkbox checked={autorizado} onChange={() => setAutorizado(!autorizado)} />}
                        label="¿Pedir autorización si las reglas no se cumplen?"
                      />

                      <FormControlLabel
                        control={<Checkbox checked={requiereSolicitud} onChange={() => setRequiereSolicitud(!requiereSolicitud)} />}
                        label="¿Requiere solicitud?"
                      />

                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={6} lg={8} marginTop={5} sx={{ borderLeft: '1px solid #e0e0e0', pl: { xs: 0, sm: 4 }, mt: { xs: 4, sm: 0 } }} padding={4}>
                    <Typography variant="h6" gutterBottom>Campos del formulario de solicitud</Typography>
                    <Box mt={4}>
                      <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
                        {categorias.map((cat) => {
                          const fields = formFields.filter(f => f.category === cat.name);
                          return (
                            <Accordion key={cat.name}>
                              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography fontWeight="bold">{cat.name}</Typography>

                                {cat.deleteable && (
                                  <RemoveCircleOutline sx={{ color: cat.deleteable ? 'red' : 'grey', marginLeft:1, height:20, width:20 }} onClick={()=>{deleteCategory(cat)}}/>
                                )}
                              </AccordionSummary>
                              <AccordionDetails>
                                <SortableContext items={fields.map(f => f.id)} strategy={verticalListSortingStrategy}>
                                  {fields.map((field, index) => (
                                    <SortableItem
                                    key={field.id}
                                    id={field.id}
                                    getFieldById={getFieldById}
                                    handleFieldChange={handleFieldChange}
                                    handleRemoveOption={handleRemoveOption}
                                    removeField={removeField}
                                    categorias={categorias}
                                    handleKeyDown={handleKeyDown}
                                  />
                                  ))}
                                </SortableContext>
                                <Box mt={2} display="flex" justifyContent="flex-end">
                                  <Button
                                    variant="outlined"
                                    startIcon={<Add />}
                                    onClick={() => addField(cat.name)}
                                    sx={{ textTransform: 'none' }}
                                  >
                                    Agregar campo
                                  </Button>
                                </Box>
                              </AccordionDetails>
                            </Accordion>
                          );
                        })}

                      </DndContext>
                    </Box>

                    <Box display="flex" flexDirection="column" gap={2} marginTop={2}>
                      <Box mt={4}>
                        <Typography variant="subtitle2" fontWeight="bold">Agregar nueva categoría</Typography>
                        <Box display="flex" gap={2} mt={1} justifyContent={"center"}>
                          <TextField
                            placeholder="Nombre de la categoría"
                            size="medium"
                            value={nuevaCategoria}
                            onChange={(e) => setNuevaCategoria(e.target.value)}

                          />
                          <Button
                            startIcon={<Add />}
                            variant="outlined"
                            onClick={() => {
                              if (nuevaCategoria.trim() && !categorias.some(c => c.name === nuevaCategoria.trim())) {
                                setCategorias([...categorias, { name: nuevaCategoria.trim(), deleteable: true }]);
                                setFormFields([...formFields, { id: Date.now(), name: '', type: 'texto', deletelable: true, required: false, options: [], inputValue: '', category: nuevaCategoria.trim() }]);
                                setNuevaCategoria('');
                              }
                            }}>
                            Agregar
                          </Button>
                        </Box>
                      </Box>

                    </Box>
                  </Grid>
                </Grid>
              </Container>
            </Box>
            <Box sx={{ position: 'fixed', bottom: 0, left: 0, width: '100%', bgcolor: 'white', p: 2, borderTop: '1px solid #eee', textAlign: 'right', }}>
                <Button variant="outlined"  sx={{width:200,fontWeight:"bold", marginRight:5}} onClick={()=>{navigate(-1)}}>Cancelar</Button>
                <Button variant="contained" color="primarybutton" sx={{width:200,fontWeight:"bold", marginRight:5}} onClick={()=>{handleOnNext()}}>Guardar</Button>
            </Box>

          </Stack>
        </Box>
      </Box>
    </AppTheme>
    </Box>
  );
};

export default ProdFinancieroDetalle;
